import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch-flat/watch-flat.js';
      import {Tickmark} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch-flat/tickmark-flat.js';
import {Label} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-flat/compass-flat.js';
import {SVGTemplateResult} from 'lit';
import {RotType, LinearRotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';
import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     width?: number;
     height?: number;
     padding?: number;
     rotation?: number;
     tickmarkSpacing?: number;
     angleSetpoint?: number | undefined;
     tickmarks?: Tickmark[];
     labels?: Label[];
     FOVIndicator?: SVGTemplateResult[];
     trackHeight?: number;
     ticksHeight?: number;
     borderRadius?: number;
     bottomBar?: boolean;
     rotType?: RotType | undefined;
     rotPosition?: LinearRotPosition;
     rotStartX?: number;
     rotEndX?: number;
     rotDotSpacing?: number;
     rotPriority?: Priority;
     rotPortStarboard?: boolean;
     rotAtZeroDeadband?: number
   }

      
  
      export type {Tickmark} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch-flat/tickmark-flat.js';
export type {Label} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-flat/compass-flat.js';
export type {SVGTemplateResult} from 'lit';
export type {RotType, LinearRotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';
export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcWatchFlat',
  props: {
    width: {},
    height: {},
    padding: {},
    rotation: {},
    tickmarkSpacing: {},
    angleSetpoint: {},
    tickmarks: {},
    labels: {},
    FOVIndicator: {},
    trackHeight: {},
    ticksHeight: {},
    borderRadius: {},
    bottomBar: { type: Boolean },
    rotType: {},
    rotPosition: {},
    rotStartX: {},
    rotEndX: {},
    rotDotSpacing: {},
    rotPriority: {},
    rotPortStarboard: { type: Boolean },
    rotAtZeroDeadband: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-watch-flat',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})